// Configuração de URLs e redirecionamentos

export const getAppUrl = (): string => {
  return process.env.REACT_APP_APP_URL || 'https://app.opsight.tech';
};

export const getLoginUrl = (): string => {
  return 'https://app.opsight.tech/login';
};

export const scrollToSection = (sectionId: string): void => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};


